<div class="l-top-navi">
  <div class="l-wrap l-wrap--sp-tb-full">
    <div class="l-wrap__inner">
      <div class="l-top-navi__inner l-top-navi__inner--has-progress">
        <div class="l-top-navi__back-area">
          <a
            id="servicing-dufy-free-preorder-guidance-sub-header-back"
            class="l-top-navi__back-link"
            [routerLink]="backUrl"
            (click)="goBack()"
          >
            <span class="u-visually-hidden" innerHTML="{{ 'reader.goBackToPreviousPage' | staticMsg }}"></span
          ></a>
        </div>
        <div class="l-top-navi__heading-area">
          <h1
            class="l-top-navi__heading-text"
            innerHTML="{{ 'm_static_message-label.preorder.title' | staticMsg }}"
          ></h1>
        </div>
      </div>
    </div>
  </div>
</div>
